/**
 * MacroBaby — Inicializações da Home (template-index).
 * Depende de: jQuery, mb-carousel.js
 */
(function ($) {
    $(function () {
        if (!$("body").hasClass("template-index")) return;

        const productLists = document.querySelectorAll(".product-list");
        const scrollableList = document.querySelector(".product-list--scrollable");

        const productListConfig = {
            items: 6,
            fullWidth: true,
            buttons: true,
            dots: false,
            responsive: {
                1360: { inherit: true, items: 5 },
                800:  { dots: false, buttons: true, items: 2, fullWidth: true }
            }
        };

        // Quick links carousel
        mbCarousel(".quick-links-custom", {
            items: 6,
            fullWidth: true,
            buttons: false,
            dots: true,
            responsive: { 800: { dots: true, items: 2, fullWidth: true } }
        });

        // Slideshow
        mbCarousel(".slideshow", {
            items: 1,
            fullWidth: false,
            buttons: true,
            dots: false
        });

        addCarousel(".quick-links-custom", {
            items: 6,
            loop: true,
            dots: true,
            nav: false,
            responsive: {
                0:   { items: 2, dots: true, loop: true, margin: 10 },
                800: { items: 6 }
            }
        });

        // Product lists
        productLists.forEach(el => mbCarousel(el, productListConfig));
        mbCarousel(scrollableList, productListConfig);

        // Remove duplicate slider thumbnail after load
        window.addEventListener("load", function () {
            const thumb = document.querySelector(".home-slider-thumbnail");
            if (thumb) thumb.remove();
        });
    });
})(jQuery);
